import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wenda",
  "use": "icon-wenda-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-wenda\"><g fill-rule=\"evenodd\"><path d=\"M9.75 4.167c-1.08 0-1.925.306-2.552.918-.642.613-.948 1.459-.948 2.538h1.663c0-.627.116-1.108.364-1.444.292-.394.744-.583 1.37-.583.497 0 .89.131 1.168.408.262.277.408.656.408 1.138 0 .364-.131.714-.394 1.035l-.175.204c-.948.846-1.516 1.459-1.706 1.852-.204.394-.292.875-.292 1.43v.204h1.677v-.204c0-.35.073-.671.22-.963.13-.262.32-.51.582-.715.7-.612 1.123-1.006 1.255-1.152.35-.466.54-1.064.54-1.793 0-.89-.292-1.59-.876-2.1-.583-.525-1.356-.773-2.304-.773zm-.263 8.414c-.32 0-.583.102-.787.307-.233.204-.335.466-.335.787 0 .32.102.583.335.788.204.204.467.32.788.32.32 0 .583-.102.816-.306.204-.204.321-.481.321-.802 0-.32-.117-.583-.32-.787a1.16 1.16 0 00-.817-.307z\" /><circle stroke=\"#BFBFBF\" stroke-width=\"1.5\" cx=\"10\" cy=\"10\" r=\"9.25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/wenda.svg
// module id = 522
// module chunks = 4